import React from 'react';
import { createPortal } from 'react-dom';
import HBMediaElement from '../HBMediaElement/HBMediaElement';

interface IProps {
    mediaPaths: string[];
}

const PreloadMediaElements = ({ mediaPaths }: IProps) =>
    createPortal(
        <div style={{ display: 'none' }}>
            {mediaPaths.map(mediaPath => (
                <HBMediaElement key={mediaPath} path={mediaPath} />
            ))}
        </div>,
        document.head
    );

export default PreloadMediaElements;
